import {
  BEGIN_SET_FEATURE_GEOMETRY,
  END_SET_FEATURE_GEOMETRY,
  SET_FEATURE_GEOMETRY_ADD_POINT,
  SET_FEATURE_GEOMETRY_END_DRAWING,
  START_SET_FEATURE_GEOMETRY,
  // EDIT_SESSION_EDIT_FEATURE,
  SET_FEATURE_SAVE_GEOMETRY
} from './actions.type';

import {
  SET_FEATURE_GEOMETRY_ACTIVE,
  SET_FEATURE_GEOMETRY_READY,
  SET_FEATURE_GEOMETRY_FEATURE_SET_ENDING,
  SET_FEATURE_GEOMETRY_FEATURE_ADD_POINT_MANUALLY,
  SET_FEATURE_GEOMETRY_POINT_CHANGED,
  SET_FEATURE_GEOMETRY_FEATURE_DELETE_POINT,
  WINDOW_NOTIFICATION_SHOW
} from './mutations.type';

import Feature from 'ol/Feature';
import { LineString, Point, Polygon } from 'ol/geom';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Style, Text, Stroke, Fill, Circle as CircleStyle } from 'ol/style';

const initialState = {
  active: false,
  ready: false,
  drawingEnded: false,
  draw: null,
  source: null,
  mapLayer: null,
  modifyInteraction: null,
  pointAdded: false,
  segments: [],
  drawnFeature: null,
  map: null,
  geometryType: null
};

export const state = Object.assign({}, initialState);

export const actions = {
  [BEGIN_SET_FEATURE_GEOMETRY](context, map) {
    if (state.active) {
      context.dispatch(END_SET_FEATURE_GEOMETRY);
    } else {
      const selectedFeatures = context.rootGetters.features.filter(f =>
        this.$store.getters.selectedMapFeatures.has(f.id)
      );
      if (
        selectedFeatures.length == 1 &&
        !selectedFeatures[0].geometry.coordinates.length
      ) {
        context.state.drawnFeature = new Feature();
        context.state.drawnFeature.setId(selectedFeatures[0].id);
        context.commit('setMap', map);
        context.dispatch(START_SET_FEATURE_GEOMETRY);
      } else {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'error',
          title: 'Uwaga!',
          message: 'Należy wybrać jeden obiekt z pustą geometrią.',
          duration: 5000
        });
      }
    }
  },
  [END_SET_FEATURE_GEOMETRY](context) {
    if (!state.active) {
      return;
    }
    context.commit(SET_FEATURE_GEOMETRY_ACTIVE, false);
    context.commit(SET_FEATURE_GEOMETRY_READY, false);
    state.map.removeLayer(state.mapLayer);
    state.draw = state.mapLayer = state.geometryType = state.drawnFeature = null;
    state.drawingEnded = state.pointAdded = false;
  },
  [START_SET_FEATURE_GEOMETRY]({ state, commit, rootGetters }) {
    const activeLayer = rootGetters.layers.find(x => x.active);

    if (!activeLayer) {
      return;
    }

    switch (activeLayer.type) {
      case 'point':
        state.geometryType = 'Point';
        break;
      case 'polygon':
        state.geometryType = 'Polygon';
        break;
      case 'linestring':
        state.geometryType = 'LineString';
        break;
      default:
        throw 'Niepoprawny typ geometrii.';
    }

    state.source = new VectorSource();
    state.source.addFeature(state.drawnFeature);
    state.mapLayer = new VectorLayer({
      source: state.source,
      zIndex: Infinity
    });
    state.map.addLayer(state.mapLayer);
    commit(SET_FEATURE_GEOMETRY_ACTIVE, true);
    commit(SET_FEATURE_GEOMETRY_READY, true);
  },
  [SET_FEATURE_GEOMETRY_ADD_POINT]({ state, dispatch }, pointCoordinates) {
    if (!state.active || state.drawingEnded) {
      return;
    }

    if (state.pointAdded) {
      dispatch(SET_FEATURE_GEOMETRY_END_DRAWING);
    } else {
      const featureGeometry = state.drawnFeature.getGeometry();
      if (featureGeometry) {
        // const coordinates = featureGeometry.getCoordinates();
        // const lastPoint = coordinates[coordinates.length - 2];

        // if (lastPoint[0] != pointCoordinates[0] || lastPoint[1] != pointCoordinates[1]) {
        //   state.pointAdded = true;
        // }
        state.pointAdded = true;
      } else {
        switch (state.geometryType) {
          case 'Point':
            state.drawnFeature.setGeometry(new Point(pointCoordinates));
            dispatch(SET_FEATURE_GEOMETRY_END_DRAWING);
            break;
          case 'LineString':
            state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
            break;
          case 'Polygon':
            state.drawnFeature.setGeometry(new Polygon([[pointCoordinates]]));
            break;
        }
        state.pointAdded = true;
      }
    }
  },
  [SET_FEATURE_GEOMETRY_END_DRAWING]({ state }) {
    state.drawingEnded = true;
  },
  async [SET_FEATURE_SAVE_GEOMETRY]({ state, dispatch, rootGetters }) {
    // const success = await dispatch(EDIT_SESSION_EDIT_FEATURE, { mapFeature: state.drawnFeature });
    // if (success) {
    //   const editSessionLayerFeature = rootGetters.editSessionMapLayer.getSource().getFeatures().find(f => f.getId() == state.drawnFeature.getId());
    //   if (editSessionLayerFeature) {
    //     editSessionLayerFeature.setGeometry(state.drawnFeature.getGeometry());
    //   }
    //   const featuresTableFeature = rootGetters.features.find(f => f.id == state.drawnFeature.getId());
    //   if (featuresTableFeature) {
    //     featuresTableFeature.geometry.coordinates = state.drawnFeature.getGeometry().getCoordinates();
    //   }
    //   dispatch(END_SET_FEATURE_GEOMETRY);
    // }
  }
};

export const mutations = {
  setMap: (state, map) => (state.map = map),
  [SET_FEATURE_GEOMETRY_ACTIVE](state, value) {
    state.active = value;
  },
  [SET_FEATURE_GEOMETRY_READY](state, value) {
    state.ready = value;
  },
  [SET_FEATURE_GEOMETRY_FEATURE_ADD_POINT_MANUALLY](state, pointCoordinates) {
    if (!state.active) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      if (state.geometryType == 'Point') {
        featureGeometry.setCoordinates(pointCoordinates);
      } else if (state.geometryType == 'LineString') {
        featureGeometry.appendCoordinate(pointCoordinates);
      } else if (state.geometryType == 'Polygon') {
        const coordinates = featureGeometry.getCoordinates();
        coordinates[0].push(pointCoordinates);
        featureGeometry.setCoordinates(coordinates);
      }
    } else {
      switch (state.geometryType) {
        case 'Point':
          state.drawnFeature.setGeometry(new Point(pointCoordinates));
          break;
        case 'LineString':
          state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
          break;
        case 'Polygon':
          state.drawnFeature.setGeometry(new Polygon([[pointCoordinates]]));
          break;
      }
    }

    state.pointAdded = true;
  },
  [SET_FEATURE_GEOMETRY_POINT_CHANGED](state, { index, coordinates }) {
    const featureGeometry = state.drawnFeature.getGeometry();
    const featureCoordinates = featureGeometry.getCoordinates();
    switch (state.geometryType) {
      case 'Point':
        featureGeometry.setCoordinates(coordinates);
        break;
      case 'LineString':
        featureCoordinates[index] = coordinates[index];
        featureGeometry.setCoordinates(featureCoordinates);
        break;
      case 'Polygon':
        featureCoordinates[0][index] = coordinates[0][index];
        featureGeometry.setCoordinates(featureCoordinates);
        break;
    }
  },
  [SET_FEATURE_GEOMETRY_FEATURE_DELETE_POINT](state, index) {
    const drawnFeatureCoordinates = state.drawnFeature
      .getGeometry()
      .getCoordinates();
    if (state.geometryType == 'LineString') {
      drawnFeatureCoordinates.splice(index, 1);
    } else {
      drawnFeatureCoordinates[0].splice(index, 1);
    }
    state.drawnFeature.getGeometry().setCoordinates(drawnFeatureCoordinates);
    state.pointAdded = true;
  },
  [SET_FEATURE_GEOMETRY_FEATURE_SET_ENDING](state, endPointCoordinates) {
    if (!state.active || state.drawingEnded || state.geometryType == 'Point') {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();
    if (featureGeometry) {
      if (state.pointAdded) {
        if (state.geometryType == 'LineString') {
          featureGeometry.appendCoordinate(endPointCoordinates);
        } else {
          const coordinates = featureGeometry.getCoordinates();
          coordinates[0].push(endPointCoordinates);
          featureGeometry.setCoordinates(coordinates);
        }
        state.pointAdded = false;
      } else {
        const coordinates = featureGeometry.getCoordinates();
        if (state.geometryType == 'LineString') {
          coordinates[coordinates.length - 1] = endPointCoordinates;
        } else {
          coordinates[0][coordinates[0].length - 1] = [
            endPointCoordinates[0],
            endPointCoordinates[1]
          ];
        }
        featureGeometry.setCoordinates(coordinates);
      }
    }
  }
};

export const getters = {
  setFeatureGeometryActive: state => state.active,
  setFeatureGeometryDrawnFeature: state => state.drawnFeature,
  setFeatureGeometryReady: state => state.ready,
  setFeatureGeometryLayer: state => state.mapLayer,
  setFeatureGeometryDrawInteraction: state => state.draw
};

export default {
  state,
  actions,
  mutations,
  getters
};
